import React from 'react';
import request from 'arcdynamic-request';
import {FIRMS} from '../../consts/tables';
import Dropdown from "../Dropdown/Dropdown";
import PropTypes from "prop-types";

const findIndex = require('lodash.findindex');
const cloneDeep = require('lodash.clonedeep');
const limit = 1000;

class SelectFirm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            items: [],
            hasChildValue: false
        };
    }

    componentDidMount() {
        this.fetch(0);
    }

    fetch(offset) {
        const options = {
            limit: {
                count: limit,
                offset: offset * limit,
            },
            column: ['NAME', 'ARCIMEDES_ROW_ID', 'PARENT_FIRM'],
            filter: [
                {
                    code: 'NAME',
                    text: '',
                    type: 'notNull',
                },
                {
                    code: 'DELETED',
                    text: '',
                    type: 'null',
                },
            ],
            filterType: 'and',
        };

        if (this.props.excludeChildren) {
            options.filter.push({
                code: 'PARENT_FIRM',
                text: '',
                type: 'null',
            })
        }

        request(arc.path.api, {
            service: 'arcimedes',
            action: 'open.datasource.table.Data.getData',
            params: ['code', FIRMS, options],
        }).then(res => {
            this.setState(prevState => {
                const items = prevState.items.concat(res.data);
                return {
                    items,
                };
            });
            if (res.data.length >= limit) {
                this.fetch(++offset);
            } else {
                const items = [];
                const index = this.handleParentAndChildFirms(cloneDeep(this.state.items));
                Object.keys(index).forEach(id => {
                    items.push(index[id].parent);
                    index[id].children.forEach(x => {
                        x.NAME = '\u00a0\u00a0– '+x.NAME;
                        items.push(x);
                    });
                });
                this.setState({items});
            }
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.newFirm !== nextProps.newFirm) {
            let items = cloneDeep(this.state.items);
            const newFirm = {...nextProps.newFirm};

            if (newFirm.PARENT_FIRM) {
                const parentFirmIndex = findIndex(items, {"ARCIMEDES_ROW_ID": newFirm.PARENT_FIRM});
                newFirm.NAME = '\u00a0\u00a0– ' + newFirm.NAME;
                items.splice(parentFirmIndex + 1, 0, newFirm);
            } else {
                items.push(newFirm);
            }

            this.setState({items});
        }
    }

    handleParentAndChildFirms(res) {
        const index = {};

        res.filter(x => !x.PARENT_FIRM)
            .sort((a,b)=> {
                if (a.NAME === 'STRIVE') {
                    return -1;
                } else if (b.NAME === 'STRIVE') {
                    return 1;
                }
                return (a.NAME < b.NAME) ? -1 : 1;
            })
            .forEach(x => {
                index['x'+x.ARCIMEDES_ROW_ID] = {
                    parent: x,
                    children: [],
                };
            });

        res.filter(x => x.PARENT_FIRM).forEach(x => {
            if (index['x'+x.PARENT_FIRM] && index['x'+x.PARENT_FIRM].children) {
                index['x'+x.PARENT_FIRM].children.push(x);
            }
        });

        return index;
    }

    render() {
        const { items } = this.state;
        const { 
            theme, 
            value, 
            valueKey,
            firmName,
            label, 
            disabled, 
            data, 
            isFilter, 
            withAddNew, 
            hasDrawer, 
            handleParentChange, 
            addNewItem,
            deleted,
            viewMode,
            ...rest,
        } = this.props;

        return (
            <Dropdown theme={theme}
                      optionsType='firm'
                      optionKey='ARCIMEDES_ROW_ID'
                      options={items}
                      value={value}
                      valueKey={valueKey}
                      firmName={firmName}
                      label={label}
                      disabled={!items || disabled}
                      data={data}
                      isFilter={isFilter}
                      withAddNew={withAddNew}
                      hasDrawer={hasDrawer}
                      handleParentChange={handleParentChange}
                      addNewItem={addNewItem}
                      deleted={deleted}
                      viewMode={viewMode}
                      {...rest}
            />
        )
    }
}

SelectFirm.propTypes = {
    theme: PropTypes.oneOf(['default', 'white', 'dark']),
    value: PropTypes.string,
    valueKey: PropTypes.string.isRequired,
    firmName:PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    data: PropTypes.object,
    withAddNew: PropTypes.bool,
    handleParentChange: PropTypes.func.isRequired,
    isFilter: PropTypes.bool,
    viewMode: PropTypes.bool,
    hasDrawer: PropTypes.bool,
    addNewItem: PropTypes.func,
    deleted: PropTypes.bool,
    isFromProperty: PropTypes.bool,
};

export default SelectFirm;
